import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";
import { map, take } from "rxjs";
import { SessionService } from "../services/session.service";

export const kycGuard: CanActivateChildFn = (route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);

  const businessId =
    route.params["businessId"] ||
    route.parent?.params["businessId"] ||
    route.parent?.parent?.params["businessId"];

  const segments = router.parseUrl(state.url).root.children["primary"]?.segments.map((s) => s.path) ?? [];
  const businessIdIndex = businessId ? segments.indexOf(String(businessId)) : -1;
  const nextSegment = businessIdIndex >= 0 ? segments[businessIdIndex + 1] : undefined;
  const isAllowedDuringKyb = nextSegment === "settings";

  return session.loadCurrentUser().pipe(
    take(1),
    map((user) => {
      const matchedBusiness = user?.businessUsers?.find((entry) => entry.businessId === businessId || entry.business?.id === businessId);
      const kycStatus = matchedBusiness?.business?.kycStatus;

      if (businessId && kycStatus !== "active" && !isAllowedDuringKyb) {
        return router.createUrlTree(["/", businessId, "settings"]);
      }
      return true;
    })
  );
};
